import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { InitialCallsComponent } from './initial-calls.component';

const ROUTES: Routes = [
  { path: '', component: InitialCallsComponent, pathMatch: 'full' },
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule.forChild(ROUTES),
  ],
  declarations: [InitialCallsComponent],
  exports: [InitialCallsComponent],
})
export class InitialCallModule {}
